import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CarLocations from 'components/widgets/autocompletes/carLocations';
import RangePicker from 'components/widgets/rangeDateTimePicker';
import ErrorHandler from 'libraries/errorHandler';
import ErrorTooltip from 'components/snippets/errorTooltip';
import buildQueryString from 'helpers/buildQueryString';
import Lang from 'libraries/Lang';
import moment from 'moment';
import LoadingModal from '../../../helpers/loadingModal';

class Car extends Component {
    constructor(props) {
        super(props);

        moment.locale(window.Locale);

        const stateValue = {
            pickupLocation: null,
            dropoffLocation: null,
            pickupCountry: null,
            dropoffCountry: null,
            pickupCity: null,
            dropoffCity: null,
            pickupCountryId: '',
            dropoffCountryId: '',
            pickupCityId: '',
            dropoffCityId: '',
            pickupDate: null,
            dropoffDate: null,
            pickupTime: { value: '10:00', text: '10:00 am' },
            dropoffTime: { value: '10:00', text: '10:00 am' },
            showDropoff: true,
            shouldValidate: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
            trip: 'gross',
            loadingModel: false,
        };

        const rules = {
            'form.pickupCountry': (country) => {
                let valid = true;

                if (country === null || Object.keys(country).length === 0) {
                    valid = 'Select a pickup country';
                }

                return valid;
            },

            'form.pickupCity': (city) => {
                let valid = true;

                if (city === null || Object.keys(city).length === 0) {
                    valid = 'Select a pickup city';
                }

                return valid;
            },

            'form.pickupLocation': (location) => {
                let valid = true;

                if (location === null || Object.keys(location).length === 0) {
                    valid = 'Select a pickup location';
                }

                return valid;
            },

            'form.dropoffCountry': (country) => {
                let valid = true;

                if (country === null || Object.keys(country).length === 0) {
                    valid = 'Select a dropoff country';
                }

                return valid;
            },

            'form.dropoffCity': (city) => {
                let valid = true;

                if (city === null || Object.keys(city).length === 0) {
                    valid = 'Select a dropoff city';
                }

                return valid;
            },

            'form.dropoffLocation': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = 'Select a dropoff location';
                }

                return valid;
            },
            'form.dates': (date) => {
                let valid = true;
                if (date === null || Object.keys(date).length === 0) {
                    valid = 'Please selected a valid pickup and dropoff date';
                }
                return valid;
            },
        };
        this.errorHandler = new ErrorHandler(rules);

        const storage = localStorage.getItem('carEngine');
        try {
            if (storage !== null && storage.length > 0) {
                Object.assign(stateValue, JSON.parse(storage));

                if (stateValue.pickupDate !== null) {
                    stateValue.pickupDate = moment(stateValue.pickupDate);
                    if (stateValue.pickupDate.isBefore(moment())) {
                        stateValue.pickupDate = moment();
                    }
                }

                if (stateValue.dropoffDate !== null) {
                    stateValue.dropoffDate = moment(stateValue.dropoffDate);
                    if (stateValue.dropoffDate.isBefore(moment())) {
                        stateValue.dropoffDate = moment().add(1, 'day');
                    }
                }
            }
        } catch (e) {
            // console.log(e);
            localStorage.removeItem('carEngine');
        }

        this.state = stateValue;

        this.onSelectLocation = this.onSelectLocation.bind(this);
        this.onSelectCountry = this.onSelectCountry.bind(this);
        this.onSelectCity = this.onSelectCity.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.changeShowDropoff = this.changeShowDropoff.bind(this);
        this.submit = this.submit.bind(this);
        this.changeTrip = this.changeTrip.bind(this);
    }

    changeTrip(event) {
        const { legs } = this.state;
        const { target } = event;

        this.setState({ trip: target.value });
    }

    onSelectCountry(country, type) {
        if (!country) return null;

        if (type === 'pickup') {
            this.setState({
                pickupCountry: country,
                pickupCountryId: country.value,
            });
        } else {
            this.setState({
                dropoffCountry: country,
                dropoffCountryId: country.value,
            });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupCountry';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffCountry';

            this.errorHandler.checkRule(formLabel, country);
        }
    }

    onSelectCity(city, type) {
        if (!city) return null;

        if (type === 'pickup') {
            this.setState({
                pickupCity: city,
                pickupCityId: city.value,
            });
        } else {
            this.setState({
                dropoffCity: city,
                dropoffCityId: city.value,
            });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupCity';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffCity';

            this.errorHandler.checkRule(formLabel, city);
        }
    }

    onSelectLocation(destination, type) {
        if (!destination) return null;

        if (type === 'pickup') {
            this.setState({ pickupLocation: destination });
        } else {
            this.setState({ dropoffLocation: destination });
        }

        const { shouldValidate } = this.state;
        let formLabel = 'form.pickupLocation';

        if (shouldValidate) {
            if (type === 'dropoff') formLabel = 'form.dropoffLocation';

            this.errorHandler.checkRule(formLabel, destination);
        }
    }

    onDateChange(pickupDate, dropoffDate) {
        let pickupDateTime = pickupDate;
        if (pickupDate) {
            const pickupDateValue = pickupDate.format('YYYY-MM-DDTHH:mm:ss');
            const dateTime = pickupDate.format('YYYY-MM-DD') + pickupDateValue.slice(10);
            pickupDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
        }

        let dropoffDateTime = dropoffDate;
        if (dropoffDate) {
            const dropoffDateValue = dropoffDate.format('YYYY-MM-DDTHH:mm:ss');
            const dateTime = dropoffDate.format('YYYY-MM-DD') + dropoffDateValue.slice(10);
            dropoffDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
        }

        this.setState({ pickupDate: pickupDateTime, dropoffDate: dropoffDateTime });

        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', pickupDate);
        }
    }

    onTimeChange(pickupTime, dropoffTime) {
        const { pickupDate, dropoffDate } = this.state;

        if (pickupTime !== null) {
            if (pickupDate) {
                const dateTime = `${pickupDate.format('YYYY-MM-DD')} ${moment(pickupTime.text, 'hh:mm A').format('HH:mm:ss')}`;
                const pickupDateTime = moment(dateTime, 'YYYY-MM-DDTHH:mm:ss');
                this.setState({ pickupDate: pickupDateTime, pickupTime });
            } else {
                this.setState({ pickupTime });
            }
        }

        if (dropoffTime !== null) {
            if (dropoffDate) {
                const datetime = `${dropoffDate.format('YYYY-MM-DD')} ${moment(dropoffTime.text, 'hh:mm A').format('HH:mm:ss')}`;
                const dropoffDateTime = moment(datetime, 'YYYY-MM-DDTHH:mm:ss');
                this.setState({ dropoffDate: dropoffDateTime, dropoffTime });
            } else {
                this.setState({ dropoffTime });
            }
        }
    }

    changeShowDropoff(e) {
        this.setState({
            showDropoff: e.target.checked,
        });
    }

    submit(flag, event) {
        event.preventDefault();
        const {
            travellers,
            carriers,
            trip,
            cabin,
            legs,
            Traveltoken,
            TravelRedirect,
        } = this.state;
        this.setState({ loadingModel : true });
        let url = '';
        if (trip == 'net') {
            const carNetElement = document.getElementById('carNetUrl');
            url = carNetElement.getAttribute('href');
        } else if (trip == 'gross') {
            const carGrossElement = document.getElementById('carGrossUrl');
            url = carGrossElement.getAttribute('href');
        }

        // let url = TravelRedirect+"/?t=" + Traveltoken;
        window.location.href = url;
        console.log('url', url);
        // window.location.href = url;
        return false;
    }

    render() {
        const errorOutput = {};
        const {
            pickupLocation,
            dropoffLocation,
            pickupCountry,
            dropoffCountry,
            pickupCity,
            dropoffCity,
            pickupCountryId,
            dropoffCountryId,
            pickupCityId,
            dropoffCityId,
            pickupTime,
            dropoffTime,
            pickupDate,
            dropoffDate,
            showDropoff,
            loadingModel,
            trip,
        } = this.state;

        const errors = this.errorHandler.getErrors();

        return (
            <>
            <LoadingModal isLoading={loadingModel} /> 
            <form className="search-car" action="">
                <input type="hidden" name="request" value="" />
                <div className="row gutter-10 mb-3 text-center">
                    <div className="col-12">
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-carNet" name="trip" value="net" onChange={this.changeTrip} checked={trip === 'net'} />
                            <label htmlFor="radio-carNet"><span>{Lang.trans('engine_cars.car_net')}</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-carGross" name="trip" value="gross" onChange={this.changeTrip} checked={trip === 'gross'} />
                            <label htmlFor="radio-carGross"><span>{Lang.trans('engine_cars.car_gross')}</span></label>
                        </div>
                    </div>
                </div>

                <div className="row gutter-10 border-top mt-2">
                    <div className="col-12 text-center mt-3">
                        <button type="button" className="btn btn-primary font-weight-600 btn-lg px-5 mx-md-2" onClick={(e) => this.submit('', e)}>
                            <span className="">{Lang.trans('buttons.search')}</span>
                        </button>
                    </div>
                </div>
            </form>
            </>
        );
    }
}

export default Car;
